module.exports = __webpack_public_path__ + "static/media/m-operator-img-003.b09f05fc.jpg";